const ToothImplant = () => (
  <svg viewBox="0 0 64 64" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 14c-4 0-7 3-7 8 0 4 1.5 7 2.5 12 .8 4 1 12 4 12 2.5 0 2.5-6 4.5-6s2 6 4.5 6 2.5-6 4.5-6 2 6 4.5 6c3 0 3.2-8 4-12 1-5 2.5-8 2.5-12 0-5-3-8-7-8-3 0-5 2-8 2s-5-2-9-2z"/>
    <path d="M32 28v18M28 34h8M28 40h8"/>
  </svg>
);

const ToothGum = () => (
  <svg viewBox="0 0 64 64" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 14c-4 0-7 3-7 8 0 4 1.5 7 2.5 12 .8 4 1 12 4 12 2.5 0 2.5-6 4.5-6s2 6 4.5 6 2.5-6 4.5-6 2 6 4.5 6c3 0 3.2-8 4-12 1-5 2.5-8 2.5-12 0-5-3-8-7-8-3 0-5 2-8 2s-5-2-9-2z"/>
    <circle cx="24" cy="34" r="1.6" fill="currentColor"/>
    <circle cx="32" cy="38" r="1.6" fill="currentColor"/>
    <circle cx="40" cy="34" r="1.6" fill="currentColor"/>
    <circle cx="28" cy="44" r="1.4" fill="currentColor"/>
  </svg>
);

const ToothShine = () => (
  <svg viewBox="0 0 64 64" className="h-12 w-12" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 18c-3.5 0-6 2.5-6 7 0 4 1.5 7 2.5 12 .8 4 1 11 3.5 11 2 0 2-5 4-5s1.7 5 4 5 2-5 4-5 1.7 5 4 5c2.5 0 2.7-7 3.5-11 1-5 2.5-8 2.5-12 0-4.5-2.5-7-6-7-2.5 0-4 1.5-6 1.5S24.5 18 22 18z"/>
    <path d="M12 12l2 4 4 2-4 2-2 4-2-4-4-2 4-2zM50 8l1.5 3 3 1.5-3 1.5L50 17l-1.5-3-3-1.5 3-1.5z"/>
  </svg>
);

const items = [
  { Icon: ToothImplant, title: "Routine Checkups & Cleanings", desc: "Regular exams and gentle cleanings to keep your smile healthy year-round." },
  { Icon: ToothGum, title: "Family & Pediatric Care", desc: "Warm, friendly dental visits tailored to patients of all ages, including children." },
  { Icon: ToothShine, title: "Whitening & Smile Makeovers", desc: "Modern cosmetic treatments to brighten your smile and boost your confidence." },
];

export function ServiceBar() {
  return (
    <section className="relative text-white" style={{ background: "var(--gradient-primary)" }}>
      <div className="container-1120 py-7 md:py-9">
        <div className="grid md:grid-cols-3 gap-6 md:gap-10">
          {items.map(({ Icon, title, desc }) => (
            <div key={title} className="flex items-start gap-4">
              <span className="shrink-0 text-white/95 [&>svg]:h-9 [&>svg]:w-9"><Icon /></span>
              <div>
                <h2 className="text-base md:text-lg font-semibold text-white tracking-tight">{title}</h2>
                <p className="mt-1 text-xs md:text-sm leading-snug text-white/85">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}